<template>
    <div class="baseInfo">
        <div class="manage-main">
            <div class="rule">
                <Menu></Menu>
                <div class="manage-right">
                    <div class="right-title">操作员管理</div>
                    <div class="auth-list">
                        <div class="auth-btn add-btn" @click="addCustomerShow()">添加操作员</div>
                    </div>
                    <table class="auth-table">
                        <thead>
                        <tr>
                            <td style="width:105px;">操作员编号</td>
                            <td style="width:78px;">姓名</td>
                            <td style="width:68px;">性别</td>
                            <td style="width:117px;">电话</td>
                            <td style="width:75px;">传真</td>
                            <td style="width:86px;">E-mail</td>
                            <td style="width:65px;">预定</td>
                            <td style="width:115px;">查看所有订单</td>
                            <td style="width:90px;">交易报表</td>
                            <td style="width:90px;">财务管理</td>
                            <td style="width:48px;">状态</td>
                            <td style="min-width:120px;">操作</td>
                        </tr>
                        </thead>
                        <tbody v-if="!isLoading">
                        <tr v-for="(item, index) in AubAccountList">
                            <td>{{item.AccountNO}}</td>
                            <td>{{item.Name}}</td>
                            <td>{{item.Sex == 0?'女':'男'}}</td>
                            <td>{{item.Phone}}</td>
                            <td>{{item.Fax}}</td>
                            <td>{{item.Email}}</td>
                            <td>{{(item.Power&1)==1?'✔':'✖'}}</td>
                            <td>{{(item.Power&2)==2?'✔':'✖'}}</td>
                            <td>{{(item.Power&4)==4?'✔':'✖'}}</td>
                            <td>{{(item.Power&8)==8?'✔':'✖'}}</td>
                            <td>{{item.IsActive?'正常':'停用'}}</td>
                            <td>
                                <a href="javascript:void(0)" style="margin-right: 15px" @click="reviseShow(item)">修改</a>
                                <a href="javascript:void(0)" class="open" v-if="!item.IsActive"
                                   @click="getSwitchStatus(item,index,'启用')">启用</a>
                                <a href="javascript:void(0)" class="close" v-if="item.IsActive"
                                   @click="getSwitchStatus(item,index,'停用')">停用</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="table-loading" v-if="isLoading">
                        <Loading :isLoading="isLoading"></Loading>
                    </div>
                    <div class="table-no-more" v-if="!isLoading&&total ==0">
                        暂无数据...
                    </div>
                </div>
            </div>
            <div class="model-account" v-if="isModelshow">
                <div class="model-bg"></div>
                <div class="model-in">
                    <div class="model-head">
                        <div class="model-title">
                            分配操作员
                        </div>
                        <div class="model-close" @click="isModelshow = false">
                            <i class="iconfont icon-close"></i>
                        </div>
                    </div>
                    <div class="model-main">
                        <div class="main-staff-info">
                            <div class="main-staff-ryinfo" v-if="!isSubmit">
                                <div class="staff-info-label">
                                    操作员编号:
                                </div>
                                <div class="staff-info-input">
                                    <input type="text" v-model="AccountNO" disabled class="disabled">
                                </div>
                            </div>
                            <div class="main-staff-ryinfo">
                                <div class="staff-info-label">
                                    姓名:
                                </div>
                                <div class="staff-info-input">
                                    <input type="text" v-model="Name" maxlength="50">
                                    <i v-if="Name!=''" class="iconfont icon-guanbi" @click="Name=''"></i>
                                </div>
                            </div>
                            <div class="main-staff-ryinfo">
                                <div class="staff-info-label">
                                    性别:
                                </div>
                                <div class="staff-info-input staff-info-check">
                                    <span @click="Sex = 1">
                                      <span class="check"><i v-if="Sex === 1" class="iconfont icon-fuxuankuang"></i></span>
                                      <span>男</span>
                                    </span>
                                    <span @click="Sex = 0">
                                      <span class="check"><i v-if="Sex === 0" class="iconfont icon-fuxuankuang"></i></span>
                                      <span>女</span>
                                    </span>
                                </div>
                            </div>
                            <div class="main-staff-ryinfo">
                                <div class="staff-info-label">
                                    手机:
                                </div>
                                <div class="staff-info-input">
                                    <input type="text" v-model="Phone" maxlength="20">
                                    <i v-if="Phone!=''" class="iconfont icon-guanbi" @click="Phone=''"></i>
                                </div>
                            </div>
                            <div class="main-staff-ryinfo">
                                <div class="staff-info-label">
                                    E-mail:
                                </div>
                                <div class="staff-info-input">
                                    <input type="text" v-model="Email" maxlength="50">
                                    <i v-if="Email!=''" class="iconfont icon-guanbi" @click="Email=''"></i>
                                </div>
                            </div>
                            <div class="main-staff-ryinfo">
                                <div class="staff-info-label">
                                    传真:
                                </div>
                                <div class="staff-info-input">
                                    <input type="text" v-model="Fax" maxlength="50">
                                    <i v-if="Fax!=''" class="iconfont icon-guanbi" @click="Fax=''"></i>
                                </div>
                            </div>
                            <div class="main-staff-ryinfo">
                                <div class="staff-info-label">
                                    密码:
                                </div>
                                <div class="staff-info-input">
                                    <input type="text" v-model="Pwd" maxlength="20" :placeholder="!isSubmit?'不改密码不用输入':''">
                                    <i v-if="Pwd!=''" class="iconfont icon-guanbi" @click="Pwd=''"></i>
                                </div>
                            </div>
                            <div class="main-staff-ryinfo">
                                <div class="staff-info-label">
                                    是否启用:
                                </div>
                                <div class="staff-info-input staff-info-check">
                  <span @click="IsActive = true">
                    <span class="check">
                        <i v-if="IsActive" class="iconfont icon-fuxuankuang"></i>
                    </span>
                    <span>启用</span>
                  </span>
                                    <span @click="IsActive = false">
                    <span class="check">
                        <i v-if="!IsActive" class="iconfont icon-fuxuankuang"></i>
                    </span>
                    <span>停用</span>
                  </span>
                                </div>
                            </div>
                            <div class="main-staff-ryinfo">
                                <div class="staff-info-label">
                                    备注:
                                </div>
                                <div class="staff-info-input staff-info-bz">
                                    <textarea v-model="Remark"></textarea>
                                </div>
                            </div>
                            <div class="main-staff-ryinfo">
                                <div class="staff-info-label">
                                    分配权限:
                                </div>
                                <div class="staff-info-input staff-info-check staff-info-bz">
                  <span @click="(Power&1)==1?Power =Power-1:Power =Power+1">
                    <span class="check"><i v-if="(Power&1)==1" class="iconfont icon-fuxuankuang"></i></span>
                    <span>预订</span>
                  </span>
                                    <span @click="(Power&2)==2?Power =Power-2:Power =Power+2">
                    <span class="check"><i v-if="(Power&2)==2" class="iconfont icon-fuxuankuang"></i></span>
                    <span>查看所有订单</span>
                  </span>
                                    <span @click="(Power&4)==4?Power =Power-4:Power =Power+4">
                    <span class="check"><i v-if="(Power&4)==4" class="iconfont icon-fuxuankuang"></i></span>
                    <span> 交易报表</span>
                  </span>
                                    <span @click="(Power&8)==8?Power =Power-8:Power =Power+8">
                    <span class="check"><i v-if="(Power&8)==8" class="iconfont icon-fuxuankuang"></i></span>
                    <span> 财务管理</span>
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="model-footer">
                        <div class="model-footer-in">
                            <div class="model-cancel" @click="isModelshow = false">取消</div>
                            <div v-if="isSubmit" class="model-submit" @click="submit">提交</div>
                            <div v-if="!isSubmit" class="model-submit" @click="revise">修改</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false" @ok="cancel"></Modal>
    </div>
</template>

<script>
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Menu from './../../common/cmpnt/menu/Menu'
    import Modal from './../../common/cmpnt/Modal/modal'

    export default {
        name: "SubAccount",
        components: {
            Menu,
            Loading,
            Modal
        },
        data: function () {
            return {
                AubAccountList: [],
                isLoading: false,
                isModelshow: false,
                isSubmit: true,
                total: 0,
                Sex: '',
                Fax: '',
                Phone: '',
                Email: '',
                Remark: '',
                CustomerNO: '',
                AccountNO:'',
                Name: '',
                Power: 0,
                Pwd: 0,
                IsActive: false,
                id: '',
                sID:'',
                sIndex:'',
                modal:{
                    show:false,
                    config:{}
                },
            }
        },
        mounted() {
            this.initData();
            document.title='操作员管理---订房易';
        },
        methods: {
            cancel(){
                var that = this;
                that.modal.show = false;
                that.getRequest({
                    url: that.Api.getSwitchStatus + '?id=' + that.sID,
                    params: ''
                }).then(res => {
                    if (res.IsSuccess) {
                        // this.initData()
                        that.AubAccountList[that.sIndex].IsActive = !that.AubAccountList[that.sIndex].IsActive
                    }
                })
            },
            revise() {
                var that = this;
                var params = {
                    Sex: that.Sex,
                    Fax: that.Fax,
                    Phone: that.Phone,
                    Email: that.Email,
                    Remark: that.Remark,
                    CustomerNO: that.CustomerNO,
                    Name: that.Name,
                    Power: that.Power,
                    Pwd: that.Pwd,
                    IsActive: that.IsActive,
                    Department: ''
                }
                that.putRequest({
                    url: that.Api.putAccount + '?id=' + that.id,
                    params: params
                }).then(res => {
                    if (res.IsSuccess) {
                        that.isModelshow = false;
                        that.initData()
                    }
                })
            },
            reviseShow(item) {
                this.isModelshow = true;
                this.isSubmit = false;
                this.Sex = item.Sex;
                this.Fax = item.Fax;
                this.Phone = item.Phone;
                this.Email = item.Email;
                this.Remark = item.Remark;
                this.CustomerNO = item.CustomerNO;
                this.Name = item.Name;
                this.Power = item.Power;
                this.IsActive = item.IsActive;
                this.Pwd = '';
                this.id = item.ID;
                this.AccountNO = item.AccountNO
            },
            submit() {
                var that = this;
                if(!that.Name){
                    that.error({title: '提示', content: '名称不能为空！'});
                    return
                }
                if(!that.Pwd){
                    that.error({title: '提示', content: '密码不能为空！'});
                    return
                }
                var params = {
                    Sex: that.Sex,
                    Fax: that.Fax,
                    Phone: that.Phone,
                    Email: that.Email,
                    Remark: that.Remark,
                    CustomerNO: that.CustomerNO,
                    Name: that.Name,
                    Power: that.Power,
                    Pwd: that.Pwd,
                    IsActive: that.IsActive,
                    Department: '',
                }
                that.postRequest({
                    url: that.Api.addAccount,
                    params: params
                }).then(res => {
                    if (res.IsSuccess) {
                        that.isModelshow = false;
                        that.initData()
                    }
                })
            },
            addCustomerShow() {
                this.isModelshow = true;
                this.isSubmit = true;
                this.Sex = 1;
                this.Fax = '';
                this.Phone = '';
                this.Email = '';
                this.Remark = '';
                this.CustomerNO = '';
                this.Name = '';
                this.Power = 0;
                this.IsActive = false;
                this.Pwd = '';
            },
            initData() {
                var that = this;
                that.isLoading = true
                var params = {
                    Name: '',
                    AccountNO: '',
                    Page: 1,
                    PageSize: 50
                }
                that.postRequest({
                    url: that.Api.getAubAccounts,
                    params: params
                }).then(res => {
                    that.isLoading = false;
                    if (res.IsSuccess) {
                        that.AubAccountList = res.Result;
                        that.total = res.Result.length
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        })
                    }
                })

            },
            getSwitchStatus(item, index ,v) {
                var that = this;
                that.sID = item.ID;
                that.sIndex = index;
                that.modal={
                    show:true,
                    content:'确定要'+ v +'，编号为:'+ item.AccountNO +'的操作员吗?',
                    yes:'确定',
                    no:'取消',
                    isComfirm:true
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/SubAccount.vue